// 📄 pages/Proyectos/components/TareaCard.tsx
import { Calendar, MessageSquare } from 'lucide-react';
import { Tarea, TareaEstado, estaVencida, venceProximo } from '../../../services/tareaService.ts';

interface TareaCardProps {
  tarea: Tarea;
  onClick: () => void;
}

const ESTADO_STYLES: Record<TareaEstado, string> = {
  'Pendiente': 'text-gray-300 bg-white/5 border-white/10',
  'En progreso': 'text-amber-300 bg-amber-500/10 border-amber-500/30',
  'Completada': 'text-emerald-300 bg-emerald-500/10 border-emerald-500/30'
};

export default function TareaCard({ tarea, onClick }: TareaCardProps) {
  const vencida = estaVencida(tarea);
  const proximaAVencer = !vencida && venceProximo(tarea);

  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-4 transition-all"
    >
      <div className="flex items-start justify-between gap-3">
        <h4 className="text-sm font-semibold text-white leading-snug">{tarea.titulo}</h4>
        <span className={`flex-shrink-0 text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border ${ESTADO_STYLES[tarea.estado]}`}>
          {tarea.estado}
        </span>
      </div>
      <div className="flex items-center gap-2 flex-wrap mt-2 text-xs">
        <span className={`flex items-center gap-1 px-2 py-0.5 rounded-full border font-semibold ${
          vencida ? 'text-red-300 bg-red-500/10 border-red-500/30' : proximaAVencer ? 'text-amber-300 bg-amber-500/10 border-amber-500/30' : 'text-gray-400 bg-white/5 border-white/10'
        }`}>
          <Calendar className="w-3 h-3" /> {tarea.fechaLimite}{vencida ? ' · Vencida' : ''}
        </span>
        <span className="text-gray-500">Asignado: <span className="text-gray-300">{tarea.asignadoANombre}</span></span>
        {tarea.hitoNombre && <span className="text-blue-300/80">· 🏁 {tarea.hitoNombre}</span>}
        {tarea.seccionRelacionada && <span className="text-gray-500">· {tarea.seccionRelacionada}</span>}
        {tarea.comentarios.length > 0 && (
          <span className="flex items-center gap-1 text-gray-500">
            <MessageSquare className="w-3 h-3" /> {tarea.comentarios.length}
          </span>
        )}
      </div>
    </button>
  );
}
